import { render, staticRenderFns } from "./PostComments.vue?vue&type=template&id=a2920b3e&scoped=true&"
import script from "./PostComments.vue?vue&type=script&lang=ts&"
export * from "./PostComments.vue?vue&type=script&lang=ts&"
import style0 from "./PostComments.vue?vue&type=style&index=0&id=a2920b3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2920b3e",
  null
  
)

export default component.exports